var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 101,
    viewBox: "0 0 86 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1693_53292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.882 43.5814C11.9704 52.3062 17.5132 59.7171 20.3986 62.3319C17.9658 73.2749 22.7265 82.0316 25.4109 85.0421C35.704 92.0566 33.6378 95.5116 51.7493 94.0638C67.7059 88.6411 72.9578 53.9774 73.9706 30.0877C68.5697 17.32 60.3345 12.8188 54.7089 10.5715C41.0601 5.01217 33.6382 7.89162 30.2669 10.451C20.4236 15.6415 16.7201 24.2392 17.0703 29.6392C13.7031 33.1878 12.8751 40.4126 12.882 43.5814Z",
    fill: "#499FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2119 44.2174C14.3916 52.3807 19.7152 59.3496 22.4796 61.8137C20.2218 72.0452 24.8075 80.2699 27.3826 83.1033C33.8413 91.6917 45.5206 94.6367 50.5529 95.0357C66.7975 98.2109 76.9262 56.0242 73.3565 31.9235C72.0643 19.0912 60.9936 11.6128 55.6197 9.47761C42.5811 4.19704 32.9239 7.63168 29.7251 10.0091C20.3729 14.8139 18.7624 26.1301 19.1261 31.1877C15.9368 34.4913 15.1878 41.2507 15.2119 44.2174Z",
    fill: "#30CB87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6569 69.798C28.7352 72.2685 30.6043 75.3471 31.4041 76.5776C31.7803 78.6073 34.6234 81.5376 35.9979 82.749C44.4763 88.1443 51.3 88.6235 54.4351 88.2875C63.04 89.1858 72.0405 65.5942 65.1073 52.7609L65.8466 46.1969L65.2225 40.068C69.892 26.2914 60.5423 18.7191 56.1737 15.586C43.2852 8.9358 36.0478 11.7746 31.5817 15.3842C21.314 24.5658 22.5327 33.4089 24.6607 38.4244L25.7865 42.8832L26.2272 51.8319L27.651 60.98L27.6569 69.798Z",
    fill: "#FFC909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.264 47.2874C31.5927 52.0617 35.3122 56.4557 37.1309 58.0559C32.5874 62.2096 33.0372 69.0258 33.83 71.9147C35.1837 80.6758 46.3262 83.6846 51.7283 84.0938C62.1062 83.9921 65.3611 72.4126 65.6914 66.6355L64.5764 63.3305L63.9272 60.0696L62.2597 53.8202L61.3903 51.9302L60.2323 46.2171C62.5612 41.7813 60.0986 35.2867 58.5762 32.5938C59.1131 25.7036 55.9788 21.4662 54.3445 20.2088C47.2809 13.1048 39.0563 16.6701 35.8269 19.3407C29.1948 24.3233 29.4388 31.5694 30.3898 34.5697C28.6858 41.2626 30.2626 45.8369 31.264 47.2874Z",
    fill: "#FF2F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_53292",
    x: 8.78195,
    y: 2.69629,
    width: 69.2899,
    height: 96.5088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1693_53292"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap7);
export default __webpack_public_path__ + "static/media/heatMap7.f1d49086bf81d1da16a608e75a6a7420.svg";
export { ForwardRef as ReactComponent };